import { usePromiseTracker } from 'react-promise-tracker';
import { SyncLoader } from 'react-spinners';

export const Sync = (props) => {
  const { promiseInProgress } = usePromiseTracker({
    area: props.area,
    delay: 0,
  });

  return (
    <>
      {promiseInProgress && (
        <div
          className={`${props.css} spinner animate__animated animate__fadeIn`}>
          <SyncLoader
            color='#004677'
            size={props.size | 4}
          />
        </div>
      )}
    </>
  );
};
